import { FC } from 'react';
import { StyledAccentStrip } from './AccentStrip.styles';
import { ACCENTSTRIP_VARIANTS, IAccentStrip } from './AccentStrip.types';

/** The AccentStrip component can be used to decorate another component with predefined color. */
export const AccentStrip: FC<IAccentStrip> = ({
  variant = ACCENTSTRIP_VARIANTS.DISCO_PINK,
  isSmall: isBasic,
  isSolid = false,
  ...others
}) => {
  return <StyledAccentStrip variant={variant} isSmall={isBasic} isSolid={isSolid} {...others} />;
};

AccentStrip.displayName = 'AccentStrip';
